import React from 'react';
import MultiFeatureIntegrationModal from '../../admin/integration/MultiFeatureIntegrationModal';
import useIntegrationMap from '../../admin/useIntegrationMap';
import type { ButtonProps } from '../../components/Button';
import Button from '../../components/Button';
import UIActions from '../../ui/UIActions';
import { useAppDispatch } from '../../app/redux/useAppSelector';

interface ManageIntegrationButtonProps {
  platform: string;
  variant?: 'link' | 'secondary';
  size?: ButtonProps['size'];
}

const ManageIntegrationButton = ({
  platform,
  variant = 'link',
  size,
}: ManageIntegrationButtonProps) => {
  const dispatch = useAppDispatch();
  const [integrationMap] = useIntegrationMap();
  const integration = integrationMap[platform];

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => {
        dispatch(
          UIActions.openModal(MultiFeatureIntegrationModal, { integration }),
        );
        dispatch(UIActions.clearToasts());
      }}
    >
      <strong>Manage integration</strong>
    </Button>
  );
};

export default ManageIntegrationButton;
